import React from "react";
const strokeWidth = 6;
const colour = "#555555";
export const IconEye = ({ handleClick = false }) => (
  <svg
    viewBox="0 0 128.505 92.852"
    onClick={() => (handleClick ? handleClick() : null)}
  >
    <path
      fill="#FFFFFF"
      stroke={colour}
      strokeWidth={strokeWidth}
      strokeMiterlimit="10"
      d="M64.253,12.368
 c-28.71,0-53.117,14.724-62.071,35.245c8.954,20.521,33.361,35.245,62.071,35.245c28.709,0,53.116-14.724,62.07-35.245
 C117.369,27.092,92.962,12.368,64.253,12.368z"
    />
    <ellipse
      fill="#FFFFFF"
      stroke={colour}
      strokeWidth={strokeWidth}
      strokeMiterlimit="10"
      cx="64.125"
      cy="46.813"
      rx="24.717"
      ry="24.321"
    />
  </svg>
);

export const IconEyeHide = ({ handleClick = false }) => (
  <svg
    viewBox="0 0 128.505 92.852"
    onClick={() => (handleClick ? handleClick() : null)}
  >
    <path
      fill="#FFFFFF"
      stroke={colour}
      strokeWidth={strokeWidth}
      strokeMiterlimit="10"
      d="M64.253,12.368
 c-28.71,0-53.117,14.724-62.071,35.245c8.954,20.521,33.361,35.245,62.071,35.245c28.709,0,53.116-14.724,62.07-35.245
 C117.369,27.092,92.962,12.368,64.253,12.368z"
    />
    <ellipse
      fill="#FFFFFF"
      stroke={colour}
      strokeWidth="4"
      strokeMiterlimit="10"
      cx="64.125"
      cy="46.813"
      rx="24.717"
      ry="24.321"
    />
    <line
      fill="none"
      stroke={colour}
      strokeWidth={strokeWidth}
      strokeMiterlimit="10"
      x1="16.268"
      y1="1.426"
      x2="107.768"
      y2="91.426"
    />
  </svg>
);

export default IconEye;
